import { gql } from '@apollo/client'
import { Banner, BannerType } from '@farol-ds/react'
import { BannerTypeEnum } from '@jusbrasil-web/shared-apollo-client/types'

import { LockIcon } from '../../../lock-icon'
import { OfferBanner_OfferLockBannerFragment } from './__generated__/offer-banner.graphql'

interface OfferBannerProps {
  offerLockBanner: OfferBanner_OfferLockBannerFragment
}

export const OfferBanner = ({ offerLockBanner }: OfferBannerProps) => {
  const { title, description, icon } = offerLockBanner
  const type = offerLockBanner.type ?? BannerTypeEnum.Discovery

  const bannerType = type.toLowerCase() as BannerType

  return (
    <Banner defaultVisible type={bannerType}>
      <Banner.Content>
        <Banner.Title>
          {icon && (
            <Banner.Icon>
              <LockIcon icon={icon} />
            </Banner.Icon>
          )}
          {title}
        </Banner.Title>
        {description && <Banner.Description>{description}</Banner.Description>}
      </Banner.Content>
    </Banner>
  )
}

OfferBanner.fragments = {
  offerLockBanner: gql`
    fragment OfferBanner_offerLockBanner on OfferLockBanner {
      type
      title
      description
      icon {
        iconType
        color
      }
    }
  `,
}
